//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { intlFormat } from 'date-fns'
import GeneralPost from './GeneralPost.vue'

export default {
  components: {
    GeneralPost
  },
  props: {
    posts: {
      type: Array,
      default: null
    }
  },
  data () {
    return {
      categories: [
        '',
        this.$i18n.t('blog.category-1') || 'Company News',
        this.$i18n.t('blog.category-2') || 'Industry News',
        this.$i18n.t('blog.category-3') || 'Product News',
        this.$i18n.t('blog.category-4') || 'Events'
      ]
    }
  },
  methods: {
    getDate (postDate) {
      try {
        return intlFormat(new Date(postDate), {
          month: 'long',
          day: 'numeric',
          year: 'numeric'
        }, {
          locale: this.$i18n.localeProperties.iso || 'en-US'
        })
      } catch (err) {
        console.log(err)
        if (typeof postDate === 'string') {
          return postDate.substring(0, 10)
        }
        return ''
      }
    },
    getPosts (start, end) {
      const posts = this.posts
      if (posts !== null && posts.length) {
        return posts.slice(start, end)
      }
      return []
    }
  }
}
